const enCommon = {
  // Navigation
  'nav.features': 'Features',
  'nav.pricing': 'Pricing',
  'nav.login': 'Login',
  'nav.signup': 'Get Started',
  'nav.dashboard': 'Dashboard',
  
  // Hero Section
  'hero.title': 'The New Standard',
  'hero.title2': 'for Link Management',
  'hero.subtitle': 'Manage QR codes, short links, and bio links',
  'hero.subtitle2': 'easily in one place',
  'hero.cta.primary': 'Try Free',
  'hero.cta.secondary': 'See How It Works',
  'hero.noCreditCard': 'Try up to 3 of each feature without signing up',
  
  // Hero Cards
  'hero.card.qr.title': 'QR Code',
  'hero.card.qr.desc': 'Generate and download instantly',
  'hero.card.short.title': 'Short Link',
  'hero.card.short.desc': 'Simplify long URLs',
  'hero.card.bio.title': 'Bio Link',
  'hero.card.bio.desc': 'All links in one place',
  
  // Guest Modal
  'guest.modal.title': 'Start Free Trial',
  'guest.modal.subtitle': 'Try 3 of each feature for free without signing up',
  'guest.modal.qr': 'QR Codes',
  'guest.modal.short': 'Short Links',
  'guest.modal.bio': 'Bio Links',
  'guest.modal.tip': '💡 Tip:',
  'guest.modal.tipText': 'Sign up required to save and manage your content',
  'guest.modal.cancel': 'Cancel',
  'guest.modal.start': 'Get Started',
  
  // Features
  'features.title': 'Everything You Need',
  'features.subtitle': 'Powerful tools to grow your business',
  
  'feature.bio.title': 'Bio Link Pages',
  'feature.bio.desc': 'Create a beautiful landing page with all your important links. Perfect for Instagram, TikTok, and social media. Update anytime, no coding required.',
  
  'feature.qr.title': 'Custom QR Codes',
  'feature.qr.desc': 'Generate branded QR codes instantly. Perfect for menus, business cards, and marketing materials. Track every scan in real-time.',
  
  'feature.links.title': 'Short Links',
  'feature.links.desc': 'Shorten any URL and track clicks. Get detailed analytics on your link performance. Share cleaner, more professional links.',
  
  'feature.analytics.title': 'Real-Time Analytics',
  'feature.analytics.desc': 'Track clicks, locations, devices, and more. Make data-driven decisions for your campaigns. See what works best.',
  
  'feature.custom.title': 'Custom Branding',
  'feature.custom.desc': 'Customize your bio page design, QR code colors, and link appearance. Match your brand perfectly.',
  
  'feature.team.title': 'Easy to Use',
  'feature.team.desc': 'No technical skills needed. Create your bio link page in 30 seconds. Update links anytime from any device.',
  
  // Pricing
  'pricing.title': 'Simple, Transparent Pricing',
  'pricing.subtitle': 'Start free, upgrade when you need more',
  'pricing.monthly': 'Monthly',
  'pricing.yearly': 'Yearly',
  'pricing.save': 'Save 20%',
  
  'plan.pro.name': 'Pro',
  'plan.pro.price': '$14',
  'plan.pro.period': 'per month',
  'plan.pro.desc': 'For creators and businesses',
  'plan.pro.feature1': 'Unlimited bio link pages',
  'plan.pro.feature2': 'Unlimited QR codes',
  'plan.pro.feature3': 'Unlimited short links',
  'plan.pro.feature4': 'Advanced analytics & insights',
  'plan.pro.feature5': 'Custom QR code designs',
  'plan.pro.feature6': 'Priority support',
  'plan.pro.cta': 'Start Pro',
  
  // CTA Section
  'cta.title': 'Ready to Get Started?',
  'cta.subtitle': 'Join thousands of creators using our platform',
  'cta.button': 'Create Your Bio Link Now',
  'cta.noCreditCard': 'No credit card required • Start free',
  
  // Footer
  'footer.about': 'LinkQR helps creators and businesses share all their important links in one place. Create beautiful bio link pages, custom QR codes, and track everything with powerful analytics.',
  'footer.features': 'Key Features',
  'footer.feature1': 'Bio Link Pages',
  'footer.feature2': 'Custom QR Codes',
  'footer.feature3': 'Short Links',
  'footer.feature4': 'Real-Time Analytics',
  'footer.contactTitle': 'Get in Touch',
  'footer.contact': 'Contact Us',
  'footer.rights': 'All rights reserved',
  
  // Contact Form
  'contact.title': 'Contact Us',
  'contact.subtitle': 'Have questions? We\'d love to hear from you',
  'contact.name': 'Name',
  'contact.email': 'Email',
  'contact.message': 'Message',
  'contact.submit': 'Send Message',
  'contact.success': 'Message sent successfully!',
  'contact.error': 'Please fill in all fields',
  
  // Common
  'common.learnMore': 'Learn More',
  'common.getStarted': 'Get Started',
  'common.tryFree': 'Try for Free',

  // How It Works Page
  'howItWorks.title': 'How It Works',
  'howItWorks.subtitle': 'Get started in 3 simple steps. Try it now without signing up!',
  
  'howItWorks.step1.title': 'Generate QR Code',
  'howItWorks.step1.desc': 'Enter your desired URL and generate a QR code instantly. Download and use it anywhere.',
  
  'howItWorks.step2.title': 'Create Short Link',
  'howItWorks.step2.desc': 'Transform long URLs into short, memorable links. Track clicks in real-time.',
  
  'howItWorks.step3.title': 'Create Bio Link',
  'howItWorks.step3.desc': 'Connect all your social media and content with one link. Create your own profile page.',
  
  'howItWorks.features.title': 'Powerful Features',
  'howItWorks.features.subtitle': 'Everything you need in one place',
  
  'howItWorks.feature1.title': 'Real-Time Analytics',
  'howItWorks.feature1.desc': 'Track QR scans, link clicks, and page views in real-time.',
  
  'howItWorks.feature2.title': 'Mobile Optimized',
  'howItWorks.feature2.desc': 'Responsive design that works perfectly on all devices.',
  
  'howItWorks.feature3.title': 'Secure Storage',
  'howItWorks.feature3.desc': 'All data is securely encrypted and stored.',
  
  'howItWorks.feature4.title': 'Customization',
  'howItWorks.feature4.desc': 'Freely customize your bio link theme.',
  
  'howItWorks.cta.title': 'Start Now',
  'howItWorks.cta.subtitle': 'Try it for free without signing up',
  'howItWorks.cta.button': 'Start for Free',
  
  'howItWorks.footer.desc': 'QR codes, short links, and bio links in one place',

  testimonials: {
    badge: 'Customer Reviews',
    title: 'What Our Users Say',
    subtitle: 'Creators worldwide are growing their audience with LinkQR',
  },
};

export default enCommon;